<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="no()"></button>
</div>
<div class="modal-body">
  <p>{{ message }}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="no()">No</button>
  <button type="button" class="btn btn-primary" (click)="yes()">Yes</button>
</div>
